import { gql } from 'apollo-boost'

export const CONFIRM_VISITATION_TO_CONSTRUCTION = gql`
  mutation confirmVisitationToConstruction($id: String!) {
    confirmSubscriptionSorted(input: $id) {
      status
    }
  }
`
